export default __webpack_public_path__ + "static/media/AxxesPoint.f01985c2.svg";